import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { api, errMsg, money } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";

const Opt = ({ id, label, checked, onChange }) => (
  <label className="flex items-center gap-3 text-sm py-1.5 cursor-pointer">
    <Checkbox data-testid={`checkout-${id}`} checked={checked} onCheckedChange={(v) => onChange(!!v)} /> {label}
  </label>
);

export const CheckoutDialog = ({ event, open, onOpenChange }) => {
  const [f, setF] = useState({ share_email: true, share_phone: false, phone: "", subscribe_text: false, subscribe_email: true });
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v }));

  const pay = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        event_id: event.id, origin_url: window.location.origin, ...f, phone: f.phone || null,
      });
      window.location.href = data.checkout_url || data.url;
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="event-checkout-modal" className="rounded-3xl sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Get your ticket</DialogTitle>
          <DialogDescription>{event.title}</DialogDescription>
        </DialogHeader>
        <div className="space-y-1">
          <p className="font-mono text-[11px] uppercase tracking-widest text-stone-500 mb-1">Share with the host</p>
          <Opt id="share-email" label="Share my email" checked={f.share_email} onChange={set("share_email")} />
          <Opt id="share-phone" label="Share my phone number" checked={f.share_phone} onChange={set("share_phone")} />
          {f.share_phone && <Input data-testid="checkout-phone-input" placeholder="Phone number" value={f.phone} onChange={(e) => set("phone")(e.target.value)} className="rounded-xl" />}
          <p className="font-mono text-[11px] uppercase tracking-widest text-stone-500 pt-3 mb-1">Updates from {event.creator?.name || "the host"}</p>
          <Opt id="subscribe-email" label="Email me about new events" checked={f.subscribe_email} onChange={set("subscribe_email")} />
          <Opt id="subscribe-text" label="Text me about new events" checked={f.subscribe_text} onChange={set("subscribe_text")} />
        </div>
        <button data-testid="checkout-pay-btn" onClick={pay} disabled={busy}
          className="mt-2 w-full inline-flex items-center justify-center gap-2 bg-[#FF5C00] hover:bg-[#E04E00] disabled:opacity-60 text-white font-semibold py-3.5 rounded-full transition-colors">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Pay {money(event.price)} with Stripe
        </button>
      </DialogContent>
    </Dialog>
  );
};
